import PageRoutes from "./components/Routes";

const App = () => {
  return <PageRoutes />;
};

export default App;
